module.exports = __webpack_public_path__ + "img/d8c146e.webp";